export class ordersPlanNo{
    OrderPlanNumber?:number;

    constructor(OrderPlanNumber?:number)
    {
        this.OrderPlanNumber=OrderPlanNumber
    }
}